import { createAsyncThunk } from '@reduxjs/toolkit'
import {
    MembershipTypeListApi,
    MemberUserListApi,
    ClubListApi,
    MembershipPlansByIdForMemberApi,
    MemberShipListApi,
    MembershipListExportToCsvApi,
    MemberShipListOldApi,
    SubMemberMemberShipListApi,
    PlanListByMemberApi,
    ChangeNewsLetterStatusApi,
    MembershipArchiveUpdateApi,
    MembershipShowDateUpdateApi,
    MembershipJoiningDateUpdateApi,
    MemberShipListsDropDownApi,
    MembershipSearchMembersApi,
    MembershipUserListWithSearchApi,
    TestMemberShipListApi,
    TestMemberShipListOldApi,
    TestSubMemberMemberShipListApi,
    TestPlanListByMemberApi,
    TestMembershipShowDateUpdateApi,
    TestMembershipSearchMembersApi,
    TestMembershipArchiveUpdateApi
} from './MembershipList.services'
import { paginationData } from '../Pagination/reducers'
import { toast } from 'react-toastify'
import _ from 'lodash'
// import { paginationData } from '../Pagination/reducers'

//services
export const ClubList = createAsyncThunk(
    'MembershipList/ClubList',
    async (data, { rejectWithValue }) => {
        try {
            const res = await ClubListApi()
            // const res2 = await MembershipTypeListApi(data)
            // const res3 = await MemberUserListApi(data.id, data)
            // console.log('ClubList---res',res,res2,res3)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const MembershipTypeList = createAsyncThunk(
    'MembershipList/TypeList',
    async (data, { rejectWithValue }) => {
        try {
            const res = await MembershipTypeListApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

//
export const MemberUserList = createAsyncThunk(
    'MembershipList/update',
    async (data, { rejectWithValue }) => {
        try {
            const res = await MemberUserListApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)
export const MembershipPlansByIdForMember = createAsyncThunk(
    'Membership/plan/detail',
    async (data, { rejectWithValue }) => {
        try {
            const res = await MembershipPlansByIdForMemberApi(data)
            return res.data
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)
export const MemberShipLists = createAsyncThunk(
    'Membership/list/club',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await MemberShipListApi(data)

            if (Number(data?.params?._limit || 0) > 1) {
                // Pagination Section
                const limit = data.params._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data.params?._page || 1,
                    totalPage: TotalPage || 1,
                    totalRecords: res?.totalRecords || 1
                }
                dispatch(paginationData(paginationObj))
            }

            return res.data
        } catch (err) {
            if (Number(data?._limit || 0) > 1) {
                const paginationObj = {
                    page: 1,
                    totalPage: 1,
                    totalRecords: 1
                }
                dispatch(paginationData(paginationObj))
            }
            toast.error(err.response.data)
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const MembershipShowDateUpdate = createAsyncThunk(
    'Membership/show/date/update',
    async (data, { rejectWithValue }) => {
        try {
            const res = await MembershipShowDateUpdateApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const MembershipJoiningDateUpdate = createAsyncThunk(
    'Membership/joining/date/update',
    async (data, { rejectWithValue }) => {
        try {
            const res = await MembershipJoiningDateUpdateApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)
export const MemberShipListOld = createAsyncThunk(
    'Membership/list/club/old',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await MemberShipListOldApi(data)

            if (Number(data?.params?._limit || 0) > 1) {
                // Pagination Section
                const limit = data.params._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data.params?._page || 1,
                    totalPage: TotalPage || 1,
                    totalRecords: res?.totalRecords || 1
                }
                dispatch(paginationData(paginationObj))
            }

            return res.data
        } catch (err) {
            if (Number(data?._limit || 0) > 1) {
                const paginationObj = {
                    page: 1,
                    totalPage: 1,
                    totalRecords: 1
                }
                dispatch(paginationData(paginationObj))
            }
            toast.error(err.response.data)
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const PlanListByMember = createAsyncThunk(
    'Plan/list/by/member',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await PlanListByMemberApi(data)

            if (Number(data?.params?._limit || 0) > 1) {
                // Pagination Section
                const limit = data.params._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data.params?._page || 1,
                    totalPage: TotalPage || 1,
                    totalRecords: res?.totalRecords || 1
                }
                dispatch(paginationData(paginationObj))
            }

            return res.data
        } catch (err) {
            if (Number(data?._limit || 0) > 1) {
                const paginationObj = {
                    page: 1,
                    totalPage: 1,
                    totalRecords: 1
                }
                dispatch(paginationData(paginationObj))
            }
            toast.error(err.response.data)
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const MembershipListExportToCsv = createAsyncThunk(
    'Membership/export/csv',
    async (data, { rejectWithValue }) => {
        try {
            const res = await MembershipListExportToCsvApi(data)

            // Create a blob URL for the CSV file with proper MIME type
            const blob = new Blob([res], { type: 'text/csv;charset=utf-8;' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'club_memberships.csv')
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)
            return { success: true }
        } catch (err) {
            if (err?.message) {
                toast.error(err.message)
            } else if (!err.response) {
                throw err
            }
            if (err?.response?.data) {
                const errorMsg = err?.response?.data?.message || err?.response?.data
                return rejectWithValue(errorMsg)
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const SubMemberMemberList = createAsyncThunk(
    'Membership/SubMember/list',
    async (data, { rejectWithValue }) => {
        try {
            const res = await SubMemberMemberShipListApi(data)

            const finalRes = _.filter(res.data, (item) => item.user_role === 'subuser')

            return finalRes
        } catch (err) {
            toast.error(err.response.data)
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const ChangeNewsLetterStatus = createAsyncThunk(
    'Membership/NewsLetter/Status',
    async (data, { rejectWithValue }) => {
        try {
            const res = await ChangeNewsLetterStatusApi(data.body.club_id, data.body)
            return res.data
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const MembershipArchiveUpdate = createAsyncThunk(
    'Membership/Archive/Update',
    async (data, { rejectWithValue }) => {
        try {
            const res = await MembershipArchiveUpdateApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)
export const MemberShipListsDropDown = createAsyncThunk(
    'Membership/list/club/dropdown',
    async (data, { rejectWithValue }) => {
        try {
            const res = await MemberShipListsDropDownApi(data)

            const list = _.map(res.data, (u) => {
                return {
                    label: u.email,
                    value: u.id
                }
            })
            return list
        } catch (err) {
            toast.error(err.response.data)
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const MembershipSearchMembers = createAsyncThunk(
    'Membership/search/members',
    async (data, { rejectWithValue }) => {
        try {
            const res = await MembershipSearchMembersApi(data)
            return res.data || []
        } catch (err) {
            if (err?.response?.data) {
                toast.error(err.response.data.message || 'Search failed')
            }
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const MembershipUserListWithSearch = createAsyncThunk(
    'MembershipList/userListWithSearch',
    async (data, { rejectWithValue }) => {
        try {
            const res = await MembershipUserListWithSearchApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

// Test Membership Thunks
export const TestMemberShipLists = createAsyncThunk(
    'TestMembership/list/club',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await TestMemberShipListApi(data)

            if (Number(data?.params?._limit || 0) > 1) {
                const limit = data.params._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data.params?._page || 1,
                    totalPage: TotalPage || 1,
                    totalRecords: res?.totalRecords || 1
                }
                dispatch(paginationData(paginationObj))
            }

            return res.data
        } catch (err) {
            if (Number(data?._limit || 0) > 1) {
                const paginationObj = {
                    page: 1,
                    totalPage: 1,
                    totalRecords: 1
                }
                dispatch(paginationData(paginationObj))
            }
            toast.error(err.response.data)
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const TestMemberShipListOld = createAsyncThunk(
    'TestMembership/list/club/old',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await TestMemberShipListOldApi(data)

            if (Number(data?.params?._limit || 0) > 1) {
                const limit = data.params._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data.params?._page || 1,
                    totalPage: TotalPage || 1,
                    totalRecords: res?.totalRecords || 1
                }
                dispatch(paginationData(paginationObj))
            }

            return res.data
        } catch (err) {
            if (Number(data?._limit || 0) > 1) {
                const paginationObj = {
                    page: 1,
                    totalPage: 1,
                    totalRecords: 1
                }
                dispatch(paginationData(paginationObj))
            }
            toast.error(err.response.data)
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const TestPlanListByMember = createAsyncThunk(
    'TestPlan/list/by/member',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await TestPlanListByMemberApi(data)

            if (Number(data?.params?._limit || 0) > 1) {
                const limit = data.params._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data.params?._page || 1,
                    totalPage: TotalPage || 1,
                    totalRecords: res?.totalRecords || 1
                }
                dispatch(paginationData(paginationObj))
            }

            return res.data
        } catch (err) {
            if (Number(data?._limit || 0) > 1) {
                const paginationObj = {
                    page: 1,
                    totalPage: 1,
                    totalRecords: 1
                }
                dispatch(paginationData(paginationObj))
            }
            toast.error(err.response.data)
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const TestSubMemberMemberList = createAsyncThunk(
    'TestMembership/SubMember/list',
    async (data, { rejectWithValue }) => {
        try {
            const res = await TestSubMemberMemberShipListApi(data)

            const finalRes = _.filter(res.data, (item) => item.user_role === 'subuser')

            return finalRes
        } catch (err) {
            toast.error(err.response.data)
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const TestMembershipShowDateUpdate = createAsyncThunk(
    'TestMembership/show/date/update',
    async (data, { rejectWithValue }) => {
        try {
            const res = await TestMembershipShowDateUpdateApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const TestMembershipSearchMembers = createAsyncThunk(
    'TestMembership/search/members',
    async (data, { rejectWithValue }) => {
        try {
            const res = await TestMembershipSearchMembersApi(data)
            return res.data || []
        } catch (err) {
            if (err?.response?.data) {
                toast.error(err.response.data.message || 'Search failed')
            }
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const TestMembershipArchiveUpdate = createAsyncThunk(
    'TestMembership/Archive/Update',
    async (data, { rejectWithValue }) => {
        try {
            const res = await TestMembershipArchiveUpdateApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)
